import Vue from 'vue'

Vue.directive('uppercase', (el: any, binding: any) => {
    let processedValue = el.value.toUpperCase();
    el.value = processedValue;
    binding.value = el.value;
});